import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '.'
import { CodeContextGroup } from '~/constants/commands'

export type ProjectSelectionOption = 'none' | 'upload' | 'codeContext' | 'mappingTable'
export type CommandGroup = CodeContextGroup | string

interface TaskFormState {
  optionsByGroup: {
    [CodeContextGroup.DATAWEAVE]: ProjectSelectionOption
    [CodeContextGroup.INTEGRATION]: ProjectSelectionOption
    [CodeContextGroup.SAMPLE_DATA]: ProjectSelectionOption
    [key: string]: ProjectSelectionOption 
  }
}

const initialState: TaskFormState = {
  optionsByGroup: {
    [CodeContextGroup.DATAWEAVE]: 'none',
    [CodeContextGroup.INTEGRATION]: 'none',
    [CodeContextGroup.SAMPLE_DATA]: 'none',

  }
}

export const taskFormSlice = createSlice({
  name: 'taskForm',
  initialState,
  reducers: {
    setGroupOption(
      state,
      action: PayloadAction<{
        group: CommandGroup
        option: ProjectSelectionOption
      }>
    ) {
      const { group, option } = action.payload
      state.optionsByGroup[group] = option
    },
    resetGroupOption(
      state,
      action: PayloadAction<{
        group: CommandGroup
      }>
    ) {
      const { group } = action.payload
      if ([CodeContextGroup.DATAWEAVE, CodeContextGroup.INTEGRATION, CodeContextGroup.SAMPLE_DATA].includes(group as CodeContextGroup)) {
        state.optionsByGroup[group] = 'none'
      } else {
        state.optionsByGroup[group] = 'upload'
      }
    }
  }
})


export const { setGroupOption, resetGroupOption } = taskFormSlice.actions

export const selectGroupOption = (group: CommandGroup) => 
  (state: RootState) => state.taskForm.optionsByGroup[group]

export default taskFormSlice.reducer
